/*
 * HomeReducer
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 */

import produce from 'immer';
import {SET_IS_OPEN} from './constants';

// The initial state of the App
export const initialState = {
  drawerIsOpen:true
}

/* eslint-disable default-case, no-param-reassign */
const SidebarReducer = (state = initialState, action) =>{
    switch (action.type) {
      case SET_IS_OPEN:
        return {
          ...state,
          drawerIsOpen:action.payload
        }
      default:
        return state; 

    }
  };

export default SidebarReducer;
